import React from "react";
import { useNavigate } from "react-router-dom";

export const InboxMetricCard = ({
  title,
  value,
  Icon,
  path,
  iconColor = "text-gray-600",
}) => {
  const navigate = useNavigate();

  return (
    <div
      className="flex flex-col items-center justify-center w-40 h-40 p-2 text-center transition-all bg-white rounded-lg shadow-xl cursor-pointer shadow-gray-40 hover:shadow-2xl hover:bg-gray-200 active:scale-95"
      onClick={() => path && navigate(path)}
      role="button"
      tabIndex={0}
    >
      {Icon && (
        <div className={`rounded-full p-3 mb-2`}>
          <Icon className={`text-xl ${iconColor}`} />
        </div>
      )}
      <h4 className="font-medium text-black font-MTNfont">{title}</h4>
      <p className="text-lg font-bold ">{value}</p>
    </div>
  );
};
